export default {
      id: "ar_conseillers-usage",
      viewBox: "0 0 80 80",
      url: "../dist/images/" + "sprite.svg#ar_conseillers-usage",
      toString: function () {
        return this.url;
      }
    }